import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer, RaikoCreatorInfo,
    RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoGridOneColumn,
    RaikoSectionContainer, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {MemorialNoteStatusTypes} from "../../MemorialNotes";
import {MemorialNoteService} from "../../../../serverService/memorialNoteService/MemorialNoteService";
import {LoadingHelper} from "../../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../../context/LoadingContext";

export default function MemorialNotePublished({memorialNoteId}) {

    const [status, setStatus] = useState(MemorialNoteStatusTypes.AWAITING_FOR_REVIEW.id);
    const [changedStatusAt, setChangedStatusAt] = useState("");
    const [changedStatusBy, setChangedStatusBy] = useState("");
    const [actionButtonLoading, setActionButtonLoading] = useState(false)

    const service = new MemorialNoteService();
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getMemorialNoteStatusFromServer()
        }
    }, [memorialNoteId]);


    function getMemorialNoteStatusFromServer() {
        loading.show()
        service.getMemorialNoteStatus(memorialNoteId)
            .then(response => {
                setStatus(response.status)
                setChangedStatusAt(convertUniversalDateTimeToPersianDateTime(response.changedStatusAt))
                setChangedStatusBy(response.changedStatusBy)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })

    }


    function handleUpdatePublishedMemorialNote() {
        setActionButtonLoading(true)
        service.updateMemorialNoteStatus(memorialNoteId, status)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setActionButtonLoading(false)
        })

    }

    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"وضعیت انتشار"}
                    hasActionButton
                    actionButtonLoadingState={actionButtonLoading}
                    actionButtonOnclick={handleUpdatePublishedMemorialNote}
                >
                    <RaikoCustomSelect
                        labelText={"وضعیت"}
                        value={status}
                        setValue={setStatus}
                        items={[
                            raikoCustomSelectItemGenerator(MemorialNoteStatusTypes.ACCEPTED.id, MemorialNoteStatusTypes.ACCEPTED.title),
                            raikoCustomSelectItemGenerator(MemorialNoteStatusTypes.REJECTED.id, MemorialNoteStatusTypes.REJECTED.title),
                            raikoCustomSelectItemGenerator(MemorialNoteStatusTypes.AWAITING_FOR_REVIEW.id, MemorialNoteStatusTypes.AWAITING_FOR_REVIEW.title),
                        ]}
                    />
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
            <RaikoCreatorInfo
                title={"اطلاعات آخرین تغییر وضعیت"}
                createdBy={changedStatusBy}
                createdAt={changedStatusAt}
                createdByTitle={"تغییر یافته توسط"}
                createdAtTitle={"تغییر یافته در تاریخ"}
            />


        </RaikoGridOneColumn>
    )
}